$(function () {

    var $footerItems = $("#site-footer .footer-item");
    $footerItems.find(".footer-heading-mobile").click(function () {
        if (!DECIX.device.isDesktop) {
            var $footerItem = $(this).parent();

            //Hide all opened footer items
            $footerItem.siblings(".active").each(function () {
                $(this).toggleClass("active");
                $(this).find(".footer-content").slideToggle("fast");
            });

            //Show clicked item
            $footerItem.toggleClass("active");
            $footerItem.find(".footer-content").slideToggle("fast");
        }
    });

});
